export default "__VITE_ASSET__S2NB6t5p__"